export type ProfileFieldKey = 
    | 'avatar_url'
    | 'full_name'
    | 'telefone'
    | 'cargo'
    | 'tamanho_empresa'
    | 'objetivo_principal'
    | 'como_conheceu';

export interface ProfileFieldItem {
    key: ProfileFieldKey;
    label: string;
    value?: string | null;
    isFilled: boolean;
}

export interface ProfileCompletenessResult {
    percent: number;
    total: number;
    completedCount: number;
    missingCount: number;
    isComplete: boolean;
    fields: ProfileFieldItem[];
    missing: ProfileFieldItem[];
    completed: ProfileFieldItem[];
}

export type ProfileLike = {
    [K in ProfileFieldKey]?: string | null;
} | null | undefined;

export const PROFILE_FIELDS_CONFIG: { key: ProfileFieldKey; label: string }[] = [
    { key: 'avatar_url', label: 'Foto de Perfil' },
    { key: 'full_name', label: 'Nome Completo' },
    { key: 'telefone', label: 'Telefone' },
    { key: 'cargo', label: 'Cargo / Profissão' },
    { key: 'tamanho_empresa', label: 'Tamanho da Empresa' },
    { key: 'objetivo_principal', label: 'Objetivo Principal' },
    { key: 'como_conheceu', label: 'Como nos conheceu' },
];

/**
 * Calcula o progresso e lista campos pendentes no perfil do usuário.
 */
export function getProfileCompleteness(profile: ProfileLike): ProfileCompletenessResult {
    if (!profile) {
        const emptyFields: ProfileFieldItem[] = PROFILE_FIELDS_CONFIG.map(f => ({
            key: f.key,
            label: f.label,
            value: null,
            isFilled: false,
        }));

        return {
            percent: 0,
            total: PROFILE_FIELDS_CONFIG.length,
            completedCount: 0,
            missingCount: PROFILE_FIELDS_CONFIG.length,
            isComplete: false,
            fields: emptyFields,
            missing: emptyFields,
            completed: [],
        };
    }

    const fields: ProfileFieldItem[] = PROFILE_FIELDS_CONFIG.map(f => {
        const val = profile[f.key];
        const isFilled = typeof val === 'string' ? val.trim().length > 0 : Boolean(val);
        return {
            key: f.key,
            label: f.label,
            value: typeof val === 'string' ? val : null,
            isFilled,
        };
    });

    const completed = fields.filter(f => f.isFilled);
    const missing = fields.filter(f => !f.isFilled);
    const percent = Math.round((completed.length / fields.length) * 100);

    return {
        percent,
        total: fields.length,
        completedCount: completed.length,
        missingCount: missing.length,
        isComplete: missing.length === 0,
        fields,
        missing,
        completed,
    };
}
